import ReactDOM from 'react-dom';
import Header from '../components/Header';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderHeader = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<Header props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering Header:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
